import React, { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import { FieldSwitch, FormFrame } from '../../ui';
import { CardSubtitle, CardTitle, CardWrapper } from './style';

type Props = {
  children?: ReactNode;
  name: string;
};

const MiscellaneousCard = ({ children, name }: Props): JSX.Element => {
  const intl = useIntl();
  return (
    <CardWrapper>
      <FormFrame>
        <CardTitle>{intl.formatMessage({ id: `miscellaneous.settings.${name}.title` })}</CardTitle>
        <CardSubtitle>
          {intl.formatMessage({ id: `miscellaneous.settings.${name}.subtitle` })}
        </CardSubtitle>
        <FieldSwitch
          name={`${name}_collect`}
          label={intl.formatMessage({ id: `miscellaneous.settings.${name}.collect-data.title` })}
          caption={intl.formatMessage({
            id: `miscellaneous.settings.${name}.collect-data.subtitle`
          })}
        />
        <FieldSwitch
          name={`${name}.required`}
          label={intl.formatMessage({ id: `miscellaneous.settings.${name}.required.title` })}
          caption={intl.formatMessage({
            id: `miscellaneous.settings.${name}.required.subtitle`
          })}
        />
        {children}
      </FormFrame>
    </CardWrapper>
  );
};

export default MiscellaneousCard;
